import * as React from "react";

type ButtonStackButtonProps = (
  | React.ButtonHTMLAttributes<HTMLButtonElement>
  | React.AnchorHTMLAttributes<HTMLAnchorElement>
) & {};

type ButtonStackFullType = React.FunctionComponent & {
  Button: React.FunctionComponent<ButtonStackButtonProps>;
};

export const ButtonStack: ButtonStackFullType = (props) => {
  return <div className="button-stack">{props.children || []}</div>;
};

const ButtonStackButton: ButtonStackFullType["Button"] = (props) => {
  const { children, ...rest } = props;
  const { href } = props as React.AnchorHTMLAttributes<HTMLAnchorElement>;

  if (href) {
    return (
      <a
        className="a-button-stack-button"
        {...(rest as React.AnchorHTMLAttributes<HTMLAnchorElement>)}
      >
        {children || []}
      </a>
    );
  } else {
    return (
      <button
        className="a-button-stack-button"
        {...(rest as React.ButtonHTMLAttributes<HTMLButtonElement>)}
      >
        {children || []}
      </button>
    );
  }
};

ButtonStack.Button = ButtonStackButton;
